import communityWalkthrough from '../../modules/community/walkthrough/st.json';

export const ST = {
  translation: {
    ...communityWalkthrough,
  },
};
